<template>
    <AffiliateLandingPage imageExt="png" imageName="lifeMart" welcomeGroup="LifeMart members" routePath="lifemart">
    </AffiliateLandingPage>
</template>
  
<script>
import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'

export default {
    components: {
        AffiliateLandingPage
    },
    name: 'LifeMartLandingPage'
}
</script>
  
<style></style>
  